import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import {
    Phone, Wifi, Zap, ReceiptText, ShieldPlus, Gamepad2, Droplets, ArrowLeftRight, Wallet, MoreHorizontal
} from "lucide-react";

const ACTIONS = [
    { type: "pulsa", label: "Pulsa", icon: Phone, color: "from-emerald-500 to-emerald-600" },
    { type: "data", label: "Paket Data", icon: Wifi, color: "from-sky-500 to-blue-600" },
    { type: "pln_token", label: "Token PLN", icon: Zap, color: "from-amber-400 to-orange-500" },
    { type: "pln_bill", label: "Tagihan PLN", icon: ReceiptText, color: "from-yellow-500 to-amber-600" },
    { type: "bpjs", label: "BPJS", icon: ShieldPlus, color: "from-teal-500 to-cyan-600" },
    { type: "game", label: "Voucher Game", icon: Gamepad2, color: "from-fuchsia-500 to-purple-600" },
    { type: "ewallet", label: "E-Wallet", icon: Wallet, color: "from-indigo-500 to-violet-600" },
    { type: "pdam", label: "PDAM", icon: Droplets, color: "from-cyan-500 to-blue-500" },
    { type: "transfer", label: "Transfer", icon: ArrowLeftRight, color: "from-slate-500 to-slate-700" },
    { type: "more", label: "Lainnya", icon: MoreHorizontal, color: "from-neutral-400 to-neutral-600" },
];


export default function QuickActions() {
    const navigate = useNavigate();
    return (
        <div className="grid grid-cols-4 gap-3" data-testid="quick-actions-grid">
            {ACTIONS.map((a, idx) => {
                const Icon = a.icon;
                return (
                    <motion.button
                        key={a.type}
                        data-testid={`action-${a.type}`}
                        initial={{ opacity: 0, y: 8 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: idx * 0.03 }}
                        whileTap={{ scale: 0.94 }}
                        onClick={() => navigate(a.type === "more" ? "/transaksi" : `/transaksi/${a.type}`)}
                        className="flex flex-col items-center gap-1.5 py-2 min-h-[80px] group"
                    >
                        <div className={`h-12 w-12 rounded-2xl bg-gradient-to-br ${a.color} text-white flex items-center justify-center shadow-md shadow-black/5 group-hover:shadow-lg transition`}>
                            <Icon className="h-5 w-5" />
                        </div>
                        <span className="text-[11px] font-medium text-center leading-tight">{a.label}</span>
                    </motion.button>
                );
            })}
        </div>
    );
}
